module.exports = __webpack_public_path__ + "static/media/home-track.55d7ef08.jpg";